/**
 * Global resources shown regardless of baseRoute.
 */
import admin from "@/containers/admin";
import itsdata from "@/containers/itsdata";
import itsdataAddressChangeQueue from "@/containers/itsdata-address-change-queue";
import whatsappBroadcasts from "@/containers/whatsapp-broadcasts";
import whatsappOutboundMessages from "@/containers/whatsapp-outbound-messages";
import cronStatus from "@/containers/cron-status";
import tenantSettings from "@/containers/tenant-settings";
import sequences from "@/containers/sequences";
import tenantApiKeys from "@/containers/tenant-api-keys";

import type { GlobalResourceConfig } from "@/types/react-admin-config";

export const GLOBAL_RESOURCES: GlobalResourceConfig[] = [
  { permission: "admins.view", resource: admin, sidebarGroup: "admin" },
  { permission: "itsdata.dump", resource: itsdata, sidebarGroup: "admin" },
  { permission: "itsdata.dump", resource: itsdataAddressChangeQueue, sidebarGroup: "admin" },
  { permission: "admins.view", resource: whatsappBroadcasts, sidebarGroup: "admin" },
  {
    permission: "whatsappOutboundMessages.view",
    resource: whatsappOutboundMessages,
    sidebarGroup: "admin",
  },
  {
    permission: "tenantSettings.view",
    resource: tenantSettings,
    name: "tenantSettings",
    sidebarGroup: "admin",
  },
  {
    permission: "cronStatus.view",
    resource: cronStatus,
    name: "cronStatus",
    sidebarGroup: "admin",
  },
  { permission: "sequences.view", resource: sequences, sidebarGroup: "admin" },
  {
    permission: "tenantApiKeys.view",
    createPermission: "tenantApiKeys.create",
    resource: tenantApiKeys,
    sidebarGroup: "admin",
  },
];
